// src/pages/customer/CustomerDashboard.tsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import Carousel from "../../components/customer/Carousel";
import LocationPopup from "../../components/customer/LocationPopup";
import AdPopup from "../../components/customer/AdPopup";
import LoginModal from "../../components/customer/LoginModal";
import ScrollAdPopup from "../../components/customer/ScrollAdPopup";
import ScrollToTop from "../../components/customer/ScrollToTop";

import * as CustomerData from "../../utils/Customer/CustomerData";
import * as ProductData from "../../utils/Customer/products";
import { ImagePath } from "../../assests";
import { BannerItem, ProductItem } from "../../utils/Customer/CustomerTypes";
import { PetsTab } from "../../components/customer/Tabs/PetsTab";
import { ServicesTab } from "../../components/customer/Tabs/ServicesTab";
import { ProductsTab } from "../../components/customer/Tabs/ProductsTab";
import { BrandItem } from "../../components/customer/TopBrandsSection";
import { IGetPetResponse } from "../../types/Response/AdminResponse";
import { useLazyGetScreenQuery } from "../../redux/actions/Customer/authCustomer";
import { useMenu } from "../../components/customer/MenuContext";
import { ScreenSection } from "../../types/Response/CustomerResponse";
import {
  useCreateCartMutation,
  useLazyGetCartQuery,
  useUpdateCartMutation,
} from "../../redux/actions/Customer/cartCustomer";

const EXPORTED_DATA_PACK = { ...CustomerData, ...ProductData, ImagePath };

const CustomerDashboard: React.FC = () => {
  const navigate = useNavigate();
  const saverSaleRef = useRef<HTMLDivElement | null>(null);

  const { mode } = useOutletContext<{
    mode: "Products" | "Pets" | "Services";
    setMode: React.Dispatch<React.SetStateAction<any>>;
  }>();

  // RTK Query Dynamic Schema Listener
  const [triggerGetScreen, { data: screenResponse, isFetching }] =
    useLazyGetScreenQuery();

  const { setMenu } = useMenu();
  useEffect(() => {
    if (screenResponse?.menu) {
      setMenu(screenResponse.menu);
    }
  }, [screenResponse, setMenu]);

  const [orderedSections, setOrderedSections] = useState<ScreenSection[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showAdPopup, setShowAdPopup] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [createCart] = useCreateCartMutation();
  const [triggerGetCart] = useLazyGetCartQuery();
  const [updateCart] = useUpdateCartMutation();
  const [referralCode, setReferralCode] = useState("");
useEffect(() => {
  const adShown = localStorage.getItem("adPopupShown");

  if (!adShown) {
    setShowAdPopup(true);
  }
}, []);


useEffect(() => {
  document.body.style.overflow = showAdPopup ? "hidden" : "";

  return () => {
    document.body.style.overflow = "";
  };
}, [showAdPopup]);
  // Synchronize Tab Modes with Backend Screen Mappings
  useEffect(() => {
    const modeKeyMap: Record<string, string> = {
      products: "productsTab",
      pets: "petTab",
      services: "serviceTab",
    };

    const targetScreen = modeKeyMap[mode.toLowerCase()] || "productsTab";
    triggerGetScreen({ screenName: targetScreen, clientType: 99 });
  }, [mode, triggerGetScreen]);
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("ref");

  if (code) {
    const referral = code.trim();

    // Save referral code
    localStorage.setItem("referralCode", referral);
    setReferralCode(referral);

    // Open login popup automatically
    setShowPopup(false);
    setShowAdPopup(false);
    setShowLoginModal(true);
  } else {
    const savedCode = localStorage.getItem("referralCode");

    if (savedCode) {
      setReferralCode(savedCode);
    }
  }
}, []);

  // Safely extract and sort visible components
  useEffect(() => {
    if (screenResponse?.sections) {
      const activeSections = [...screenResponse.sections]
        .filter((s) => s.isVisible)
        .sort((a, b) => a.displayOrder - b.displayOrder);
      setOrderedSections(activeSections);
    } else {
      setOrderedSections([]);
    }
  }, [screenResponse]);

  // Extract dynamic top carousel banners or fallback if blank
  // const getHeroItems = () => {
  //   const mainCarouselData = orderedSections.find(
  //     (s) => s.sectionName === "MainCarousel",
  //   )?.data;
  //   if (mainCarouselData && mainCarouselData.length > 0) {
  //     return mainCarouselData;
  //   }
  //   if (mode === "Pets") return CustomerData.petCarouselImages;
  //   if (mode === "Services") return CustomerData.serviceCarouselImages;
  //   return CustomerData.CarouselImages;
  // };

  const handleProductClick = (product: ProductItem) => {
    console.log(product,"product")
    if(product.ItemType==='Custom'){
      if(product.RedirectUrl){
  window.location.href = product.RedirectUrl
      }

    }
    else{
    navigate(`/productpage/customerneproductpage/${product.ProductId}`, {
      state: { product },
    });
    }

  };
const handleViewAllClick = () =>
    navigate("/productpage/videos", {
        state: {
            source: "AllProducts",
            data: {},
            isPet: true,
        },
    });

    const handleViewAllClickPetsVideos = () =>
    navigate("/productpage/videos", {
        state: {
            source: "AllProducts",
            data: {},
            isPet: false,
        },
    });
      const handlePetsViewAllClick = () =>
    navigate("/productpage/customerpetlistingscreen"
    );


    


  const handleBrandClick = (brand: any) =>
    navigate("/productpage/productListingScreen", {
      state: {
        source: "Brand",
        data: {
          brandId: brand.id,
        },
      },
    });

const handleBookGroomingClick = (item: any) => {
  // 1. Custom / External items -> Open redirectUrl in a new tab
  if (item.itemType === "Custom" || item.redirectUrl) {
    if (item.redirectUrl) {
      const url = item.redirectUrl.startsWith("http") 
        ? item.redirectUrl 
        : `https://${item.redirectUrl}`;
      window.location.href = url;
    }
    return;
  }

  // 2. Dynamic / Internal navigation -> Pass ID via state or URL params
  const itemId = String(item.id);

  switch (itemId) {
    case "1":
    case "26": // Grooming from JSON
      navigate("/customergroomingbookingservice", { state: { id: item.id, service: item } });
      break;
    case "2":
      navigate("/mobilegroomingservice", { state: { id: item.id, service: item } });
      break;
    case "28":
      navigate("/customergroomingbookingservice", { state: { id: item.id, service: item } });
      break;
    case "4":
    case "27": // Pet Taxi from JSON
      navigate("/pettaxiservice", { state: { id: item.id, service: item } });
      break;
    default:
      // Fallback: dynamic route or default service screen
      navigate(`/customergroomingbookingservice`, { state: { id: item.id, service: item } });
      break;
  }
};

  const handlePetTrainingClick = () => {
     navigate("/customergroomingbookingservice", { state: { id:28 } });
  };

  const onPromoClick = (promoType: "relocation" | "vet_clinic") => {
    if (promoType === "relocation") {
      navigate("pettaxiservice");
    } else if (promoType === "vet_clinic") {
      console.log("cLICKED");
    }
  };

  const handlePetTaxiBannerClick = () => {
    navigate("customergroomingbookingservice");
  };

  const addProductToCart = async (productId: number) => {
    try {
      await createCart({
        productId: Number(productId),
        quantity: 1,
      }).unwrap();
      await triggerGetCart();
      // setIsOpen(true);
    } catch (error) {
      console.error("Add to Cart validation exceptions:", error);
    }
  };
const handlePeekCarosalClick = (data: any) => {
  console.log(data, "data");
  console.log(data, "navigation data");

  const itemId = String(data?.action?.id ?? "");
  const item = data?.action;

  if (data?.action?.type === "Brand") {
    navigate("/productpage/productListingScreen", {
      state: {
        source: "Brand",
        data: {
          brandId: data.action.id,
        },
      },
    });
  } 
  
  else if (data?.action?.type === "Pet") {
    navigate(`/productpage/PetDetailScreen/${data.action.id}`);
  } 
  
  else if (data?.action?.type === "Service") {
    switch (itemId) {
      case "1":
      case "26": // Grooming
        navigate("/customergroomingbookingservice", {
          state: {
            id: item.id,
            service: item,
          },
        });
        break;

      case "2":
        navigate("/mobilegroomingservice", {
          state: {
            id: item.id,
            service: item,
          },
        });
        break;

      case "28": // Grooming
        navigate("/customergroomingbookingservice", {
          state: {
            id: item.id,
            service: item,
          },
        });
        break;

      case "4":
      case "27": // Pet Taxi
        navigate("/pettaxiservice", {
          state: {
            id: item.id,
            service: item,
          },
        });
        break;

      default:
        navigate("/customergroomingbookingservice", {
          state: {
            id: item.id,
            service: item,
          },
        });
        break;
    }
  } 
  
  else {
    navigate("/productpage/productListingScreen", {
      state: {
        source: "Category",
        data: {
          categoryId: data.action.id,
        },
      },
    });
  }
};
  const handleCheckoutClicks = () => {
    navigate("/cartpage/customercartpage");
  };
  const onViewAllFlashDealsClick = () =>{
    navigate("/productpage/productListingScreen");
  }

  return (
    <div className="min-h-screen bg-white">
      {/* <LocationPopup
        isOpen={showPopup}
        onClose={() => {
          setShowPopup(false);  
          if (!localStorage.getItem("adPopupShown")) setShowAdPopup(true);
        }}
        onConfirm={() => {
          setShowPopup(false);
          if (!localStorage.getItem("adPopupShown")) setShowAdPopup(true);
        }}
        onLoginClick={() => {
          setShowPopup(false);
          setShowLoginModal(true);
        }}
      />
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
          referralCode={referralCode}
      /> */}
  
      {showAdPopup && (
  <AdPopup
    isOpen={showAdPopup}
    onClose={() => {
      localStorage.setItem("adPopupShown", "true");
      setShowAdPopup(false);
    }}
  />
)}

      {/* <div className="pb-2">
        <Carousel
          items={getHeroItems()}
          onItemClick={(item) => console.log("Hero Clicked", item)}
        />
      </div> */}

      {isFetching && !screenResponse ? (
        <div className="flex h-[40vh] items-center justify-center">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-mainBrandColor border-t-transparent" />
        </div>
      ) : (
        <>
          {mode === "Products" && (
            <ProductsTab
              orderedSections={orderedSections}
              data={EXPORTED_DATA_PACK}
              handlers={{
                onViewAllClick: handleViewAllClickPetsVideos,
                onProductClick: handleProductClick,
                onBrandClick: (brand: any) => handleBrandClick(brand),
                handlePeekCarouselClick:(data:any)=>  handlePeekCarosalClick(data),
                handleCheckoutClick: () => handleCheckoutClicks(),
                onViewAllFlashDealsClick: () => onViewAllFlashDealsClick (),
                handleClickDog: (p: any) =>
                  navigate(`/productpage/PetDetailScreen/${p.id}`, {
                    state: { product: p },
                  }),
                onCategorySlideClick: (category: any) => {
                  console.log("Selected Category", category);
                  navigate("/productpage/productListingScreen", {
                    state: {
                      source: "Category",
                      data: {
                        categoryId: category.id,
                        title: category.name,
                      },

                    },
                  });
                },
                onCategoryClick: (category: any) => {
                  console.log("Selected Pet Category", category);

                  navigate("/productpage/productListingScreen", {
                    state: {
                      source: "Category",
                      data: {
                        categoryId: category.id,
                        title: category.name,
                      },
                    },
                  });
                },

                onBannerClick: (banner: any) => {
                  console.log("Selected Pet Banner", banner);

                  const targetUrl =
                    banner?.customUrl ??
                    banner?.CustomUrl ??
                    banner?.redirectUrl ??
                    banner?.RedirectUrl ??
                    "";

                  if (targetUrl) {
                   window.location.href = targetUrl;
                  }
                  else{
                    handlePeekCarosalClick(banner)
                  }
                },
              }}
              saverSaleRef={saverSaleRef}
            />
          )}

          {mode === "Pets" && (
            <PetsTab
              orderedSections={orderedSections}
              data={EXPORTED_DATA_PACK}
              handlers={{
                onViewAllClick: handleViewAllClick,
                petsViewAll:handlePetsViewAllClick,

                handleClickDog: (p: any) =>
                  navigate(`/productpage/PetDetailScreen/${p.id}`, {
                    state: { product: p },
                  }),
                  onVideoClick:(videoItem:any)=>{     navigate(`/productpage/PetDetailScreen/${videoItem.PetId }`, {
                    state: { product: videoItem.PetId },
                  })},
                      onBannerClick: (banner: any) => {
                  console.log("Selected Pet Banner", banner);

                  const targetUrl =
                    banner?.customUrl ??
                    banner?.CustomUrl ??
                    banner?.redirectUrl ??
                    banner?.RedirectUrl ??
                    "";

                  if (targetUrl) {
                 window.location.href = targetUrl;
                  }
                  else{
                    handlePeekCarosalClick(banner)
                  }
                },

                onCategoryClick: (category: any) => {
                  console.log("Selected Pet Category", category);

                  navigate("/productpage/customerpetlistingscreen", {
                    state: {
                      source: "PetCategory",
                      data: category,
                      categoryId: category.id,
                    },
                  });
                },
              }}
            />
          )}

          {mode === "Services" && (
            <ServicesTab
              orderedSections={orderedSections}
              handlers={{
                onBookGrooming: () => { },
                handleBookGroomingClick: (item: any) =>
                  handleBookGroomingClick(item),
                handlePetTrainingClick: handlePetTrainingClick,
                onPromoClick: onPromoClick,
                handlePetTaxiBannerClick: handlePetTaxiBannerClick,
                    onBannerClick: (banner: any) => {
                  console.log("Selected Pet Banner", banner);

                  const targetUrl =
                    banner?.customUrl ??
                    banner?.CustomUrl ??
                    banner?.redirectUrl ??
                    banner?.RedirectUrl ??
                    "";

                  if (targetUrl) {
                  window.location.href = targetUrl;
                  }
                  else{
                    handlePeekCarosalClick(banner)
                  }
                },
              }}
              servicesItems={CustomerData.servicesItems}
              selectedPetType={null}
              ImagePath={{ PetTaxiBanner: ImagePath.PetTaxiBanner }}
            />
          )}
        </>
      )}

      <ScrollAdPopup targetRef={saverSaleRef} />
      <ScrollToTop />
    </div>
  );
};

export default CustomerDashboard;
